import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaHome, FaExclamationTriangle } from "react-icons/fa";

// not found component
const NotFound = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#14263b",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        color: "white",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          width: "100%",
        }}
      >
        {/* Icon */}
        <div style={{ marginBottom: "30px" }}>
          <FaExclamationTriangle
            style={{
              fontSize: "80px",
              color: "#F6630D",
              opacity: 0.8,
            }}
          />
        </div>

        {/* Title */}
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "15px",
            color: "white",
          }}
        >
          {t("notFound.title")}
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: "18px",
            color: "#B3B3B3",
            marginBottom: "40px",
            lineHeight: 1.6,
          }}
        >
          {t("notFound.description")}
        </p>

        {/* Button */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => navigate("/")}
            style={{
              backgroundColor: "#AC2000",
              color: "white",
              border: "none",
              padding: "14px 28px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 6px rgba(172, 32, 0, 0.3)",
            }}
            onMouseEnter={e => {
              e.target.style.backgroundColor = "#8B1A00";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 12px rgba(172, 32, 0, 0.4)";
            }}
            onMouseLeave={e => {
              e.target.style.backgroundColor = "#AC2000";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 6px rgba(172, 32, 0, 0.3)";
            }}
          >
            <FaHome />
            {t("notFound.goHome")}
          </button>
        </div>

        {/* Decorative Elements */}
        <div
          style={{
            marginTop: "60px",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            opacity: 0.3,
          }}
        >
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#F6630D",
                animation: `pulse 2s ease-in-out infinite ${i * 0.2}s`,
              }}
            />
          ))}
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.2);
            }
          }
        `}
      </style>
    </div>
  );
};

export default NotFound;
